<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-02-13 09:16:22
-->
<template>
    <div>
        <a-breadcrumb :routes="routeData">
            <template #itemRender="{ route }">
                <span v-if="routeData.indexOf(route) === routeData.length - 1">
                    {{ $t(`${route.meta.lang}`) }}
                </span>
                <router-link v-else :to="`${route.path}`">
                    {{ $t(`${route.meta.lang}`) }}
                </router-link>
            </template>
        </a-breadcrumb>
    </div>
</template>

<script setup>
    import {onMounted, reactive, ref,watch} from 'vue';
    import { useRoute } from 'vue-router'
    
    const route = useRoute()

    // 设置面包屑导航
    let routeData = ref([])
    function getBreadcrumb(){
        return route.matched.filter(item=>item.name !== 'Index' && item.meta)
    }

    watch(
        () => route.path,
        () => {
            if(route.path !== 'Index' && route.path !== 'Home'){
                routeData.value = getBreadcrumb()
            }
            // console.log(routeData.value,'routeData')
        }
    )

    onMounted(()=>{
        routeData.value = getBreadcrumb()
    })
</script>

<style lang="scss" scoped>

</style>